import { AxiosResponse } from 'axios'
import { axiosClient, unauthenticatedAxiosClient } from '@App/api/api-client'
import Pathes from '@App/dicts/pathes'
import { PaginationBody } from '@Entities/pagination'
import { PublicRecording, RecordingList } from '@Entities/matching/recording-group-details'
import { ResultPage } from '@Entities/result-page'

export const getDspRecordingDetails = (recordingId: string): Promise<AxiosResponse> =>
    axiosClient.get<any>(Pathes.RightsHolder.dspRecordingDetails(recordingId))

export const getDspRecordingsForSongCode = (
    songCode: string,
    pagination: PaginationBody
): Promise<AxiosResponse<RecordingList>> =>
    axiosClient.get<RecordingList>(Pathes.RightsHolder.dspRecordingsForSongCode(songCode, pagination))

export const getPubRecordingsForSongCode = (
    songCode: string,
    pagination: PaginationBody
): Promise<AxiosResponse<ResultPage<PublicRecording>>> =>
    unauthenticatedAxiosClient.get<ResultPage<PublicRecording>>(
        Pathes.RightsHolder.publicRecordingsForSongCode(songCode, pagination)
    )
